export enum MegaMenuSortingType {
  List = "list",
  Parent = "parent"
}

export enum HorizontalAlign {
  Left = "left",
  Center = "center",
  Right = "right"
}

export interface MegaMenuItemOptions {
  align: HorizontalAlign;
  sorting: MegaMenuSortingType;
  columns: number;
  content?: string;
}

export interface MenuItem {
  id: string;
  label: string;
  link: string;
  openInNewWindow: boolean;
  isEnabled: boolean;
  isPermanentRedirect: boolean;
  name: string;
  parentId: string | null;
  sortOrder: number;
  title?: string | null;
  isCurrent: boolean;
  megaOptions?: MegaMenuItemOptions;
  children: MenuItem[];
}
